import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_premium-tech-portal/artifacts/mv16i1vi_Logo%20edited.jpg';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-white relative overflow-hidden" data-testid="main-footer">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#0096D6]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#0096D6]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        {/* Main Footer */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img
              src={LOGO_URL}
              alt="Real Tech Services"
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-slate-400 font-manrope leading-relaxed mb-6 max-w-sm">
              Strategic access to high-performance computing hardware and technology products at extremely competitive wholesale prices across the world.
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-outfit text-lg font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  Our Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Products Links */}
          <div>
            <h4 className="font-outfit text-lg font-semibold mb-6">Products</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/products?category=Audio" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  Audio Equipment
                </Link>
              </li>
              <li>
                <Link to="/products?category=Wearables" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  Wearables
                </Link>
              </li>
              <li>
                <Link to="/products?category=Mobile" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  Mobile Devices
                </Link>
              </li>
              <li>
                <Link to="/products?category=Computing" className="text-slate-400 hover:text-[#0096D6] transition-colors duration-300 font-manrope">
                  Computing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-outfit text-lg font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-[#0096D6] flex-shrink-0 mt-0.5" />
                <div className="font-manrope text-sm leading-relaxed">
                  <span className="block">40 Bank Street, Level 18 Servcorp,</span>
                  <span className="block">Canary Wharf, London,</span>
                  <span className="block">E14 5NR,</span>
                  <span className="block">United Kingdom</span>
                </div>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Phone className="w-5 h-5 text-[#0096D6] flex-shrink-0" />
                <span className="font-space">+44(0) 203 059 4550</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Mail className="w-5 h-5 text-[#0096D6] flex-shrink-0" />
                <span className="font-manrope">info@realtechservices.co.uk</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="py-6 border-t border-white/10">
          <p className="text-slate-500 text-xs font-manrope leading-relaxed max-w-4xl">
            All business transactions are subject to our internal terms and conditions of trade, which predominantly apply under the jurisdiction of the United Kingdom. By engaging with Real Tech Services Ltd, you acknowledge and agree to be bound by these terms. For full details, please contact us directly.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm font-manrope">
            © {currentYear} Real Tech Services Ltd. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <Link to="/compliance" className="hover:text-[#0096D6] transition-colors duration-300" data-testid="footer-compliance-link">Export Compliance</Link>
            <a href="#" className="hover:text-[#0096D6] transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="hover:text-[#0096D6] transition-colors duration-300">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
